import React from "react";
import { Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import SpendDashboard from "./components/Rapid_Insights/SpendDashboard";
import { MsalProvider } from "@azure/msal-react";
import ProtectedRoute from "./components/Rapid_Insights/SSO";
import SupplierProfile from "./components/Rapid_Insights/SupplierProfile";
import Personas from "./components/Rapid_Insights/Personas";
import { FileProvider } from "./components/Rapid_Insights/FileContext";
import MetacubeInsights from "./components/Rapid_Insights/MetacubeInsights";
import { BenchmarksProvider } from "./components/Rapid_Insights/benchmarks-store";
import Home from "./components/Spend Chat Agent/Home";
import AgentKai from "./components/Spend Chat Agent/AgentKai";
import SelectFile from "./components/Spend Chat Agent/SelectFile";
import SPIHome from "./components/SPI/SPIHome";
import ValueAssessment from "./components/ValueAssessment";
import { WorkspaceProvider } from "./context/WorkspaceContext";
import SupplierIntelligenceHome from "./components/Supplier_Intelligence/SupplierIntelligenceHome";
import PlanProduct from "./components/PlanProduct";
import PlanProductClient from "./components/PlanProduct/PlanProductClient";
import PlanProductConsultant from "./components/PlanProduct/PlanProductConsultant";
import PlanProductParquetConverter from "./components/PlanProduct/PlanProductParquetConverter";
import RapidAIChemicalsPage from "./components/RAChemicals/RapidAIChemicalsPage";
import KOSDeploymentTracker from "./components/KOSDeploymentTracker/KOSDeploymentTracker";
import { msalInstance } from "./msalConfig";

function App() {
  console.log("@".repeat(40));
  console.log("Fronend Version 5 : Magic Cube With Custom Domain Reflection");
  console.log("@".repeat(40));

  return (
    <MsalProvider instance={msalInstance}>
      <FileProvider>
        <BenchmarksProvider>
          <WorkspaceProvider>
            <Routes>
            {/* Other routes */}
            <Route
              exact
              path="/"
              element={
                <ProtectedRoute>
                  {" "}
                  <SpendDashboard />{" "}
                </ProtectedRoute>

                // <SpendDashboard />
              }
            />

            <Route
              exact
              path="/personas"
              element={
                <ProtectedRoute>
                  {" "}
                  <Personas />{" "}
                </ProtectedRoute>

                // <SpendDashboard />
              }
            />

            <Route
              path="/supplierprofile/:supplierName"
              element={
                <div>
                  <SupplierProfile />
                </div>
              }
            />

            <Route
              // path="/agentKAI/orchestrator"
              path="/procure_assist/orchestrator"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />

            <Route
              // path="/agentKAI"
              path="/procure_assist"
              element={
                <ProtectedRoute>
                  <AgentKai />
                </ProtectedRoute>
              }
            />

            <Route
              // path="/agentKAI/selectFile"
              path="/procure_assist/selectFile"
              element={
                <ProtectedRoute>
                  <SelectFile />
                </ProtectedRoute>
              }
            />

            <Route
              path="/metacube-insights"
              element={
                <ProtectedRoute>
                  {" "}
                  <MetacubeInsights />{" "}
                </ProtectedRoute>
              }
            />
            <Route
              path="/kos-solutions"
              element={
                <ProtectedRoute>
                  {" "}
                  <SPIHome />{" "}
                </ProtectedRoute>
              }
            />

            <Route
              path="/value-assessment"
              element={
                <ProtectedRoute>
                  <ValueAssessment />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/supplier-intelligence"
              element={
                <ProtectedRoute>
                  <SupplierIntelligenceHome />
                </ProtectedRoute>
              }
            />

            <Route
              path="/plan-product-home"
              element={
                <ProtectedRoute>
                  <PlanProduct />
                </ProtectedRoute>
              }
            />
            <Route
              path="/plan-product/consultant"
              element={
                <ProtectedRoute>
                  <PlanProductConsultant />
                </ProtectedRoute>
              }
            />
            <Route
              path="/plan-product/client"
              element={
                <ProtectedRoute>
                  <PlanProductClient />
                </ProtectedRoute>
              }
            />
            {/* Alias routes (local/dev convenience) */}
            <Route
              path="/consultant"
              element={
                <ProtectedRoute>
                  <PlanProductConsultant />
                </ProtectedRoute>
              }
            />
            <Route
              path="/plan-product/parquet"
              element={
                <ProtectedRoute>
                  <PlanProductParquetConverter />
                </ProtectedRoute>
              }
            />
            <Route
              path="/parquet"
              element={
                <ProtectedRoute>
                  <PlanProductParquetConverter />
                </ProtectedRoute>
              }
            />
            <Route
              path="/RapidAI_Chemicals"
              element={
                <ProtectedRoute>
                  <RapidAIChemicalsPage />
                </ProtectedRoute>
              }
            />

            {/* KOS Deployment Tracker — clean slug + literal alias requested */}
            <Route
              path="/kos-deployment-tracker"
              element={
                <ProtectedRoute>
                  <KOSDeploymentTracker />
                </ProtectedRoute>
              }
            />
            <Route
              path="/KOS Deployment Tracker"
              element={
                <ProtectedRoute>
                  <KOSDeploymentTracker />
                </ProtectedRoute>
              }
            />

            </Routes>
            
          </WorkspaceProvider>
        </BenchmarksProvider>
      </FileProvider>
    </MsalProvider>
  );
}

export default App;
